export class TargetSystemModel {
  constructor(public isGigyaSwitchOn: boolean) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/target-system.model.ts